import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBIcon,
  MDBTextArea,
} from "mdb-react-ui-kit";
import Form from "react-bootstrap/Form";

import "../sso-management.css";
import "./GroupEditModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { DualPicklist } from "Projects/CC_cubi_clan_project/GlobalComponents/DualPicklist/DualPicklist";

export class GroupEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showGroupEditModal: this.props.showGroupEditModal,
      data: Object.assign(
        { IDGrupo: null, nombre: "", descripcion: "" },
        this.props.data
      ),
      appsData: [],
      selectedApp: "",
      appPermisoList: [],
      permisoListAvailable: [],
      permisoListSelected: [],
      filaSeleccionadaAdd: null,
      filaSeleccionadaRemove: null,
      // Map: appId -> [{label, value}] of selected permisos per app
      mapAppPermisosSelected: {},
      grupoUsuarios: [],
      // User editing
      allUsers: [],
      usersAvailable: [],
      usersSelected: [],
      filaUserAdd: null,
      filaUserRemove: null,
      // Subgroups
      allGrupos: [],
      subgruposAvailable: [],
      subgruposSelected: [],
      filaSubgrupoAdd: null,
      filaSubgrupoRemove: null,
      // Group-App associations
      appsAvailable: [],
      appsSelected: [],
      filaAppAdd: null,
      filaAppRemove: null,
    };
  }

  componentDidMount() {
    this.getApps();
    this.loadAllUsers();
    if (this.state.data.IDGrupo) {
      this.loadGrupoDetail();
    }
    this.scrollModalToTop();
  }

  scrollModalToTop() {
    setTimeout(() => {
      const el = document.querySelector('.modal.show');
      if (el) el.scrollTop = 0;
    }, 150);
  }

  async loadGrupoDetail() {
    this.props.onLoading(true);

    let method = "getGrupo?IDGrupo=" + this.state.data.IDGrupo;

    await doFetch("SSO", method, null)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          let grupoData = data.DATA;

          // Build mapAppPermisosSelected from grupo permisos
          let map = {};
          if (grupoData.permisos) {
            for (let p of grupoData.permisos) {
              let appId = String(p.IDAplicacionFK);
              if (!map[appId]) {
                map[appId] = [];
              }
              map[appId].push({
                label: p.permisoNombre,
                value: {
                  IDPermiso: p.IDPermisoFK,
                  nombre: p.permisoNombre,
                },
              });
            }
          }

          // Build subgrupos selected
          let subgruposSelected = [];
          if (grupoData.subgrupos) {
            subgruposSelected = grupoData.subgrupos.map((sg) => ({
              label: sg.nombre,
              value: { IDGrupo: sg.IDGrupo, nombre: sg.nombre, descripcion: sg.descripcion },
            }));
          }

          // Build apps selected
          let appsSelected = [];
          if (grupoData.aplicaciones) {
            appsSelected = grupoData.aplicaciones.map((a) => ({
              label: a.appNombre + " - " + a.appTitulo,
              value: { IDAplicacion: a.IDAplicacionFK, nombre: a.appNombre, titulo: a.appTitulo },
            }));
          }

          this.setState({
            data: {
              IDGrupo: grupoData.IDGrupo,
              nombre: grupoData.nombre,
              descripcion: grupoData.descripcion || "",
            },
            mapAppPermisosSelected: map,
            grupoUsuarios: grupoData.usuarios || [],
            subgruposSelected: subgruposSelected,
            appsSelected: appsSelected,
          }, () => {
            this.loadAllGruposForSubgroups();
            this.updateAppsAvailable();
            this.updateUsersAvailable();
          });
        }
      })
      .catch((error) => {
        console.error("Error al obtener grupo:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  getApps() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllAplicaciones", null)
      .then((response) => response.json())
      .then((data) => {
        let apps = data.DATA;
        this.setState({ appsData: apps }, () => {
          this.updateAppsAvailable();
        });
        if (apps.length > 0) {
          let firstAppId = String(apps[0].IDAplicacion);
          this.setState({ selectedApp: firstAppId });
          this.fillPermisos(firstAppId);
        }
      })
      .catch((error) => {
        console.error("Error al obtener apps:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  updateAppsAvailable() {
    let appsAvailable = this.state.appsData
      .filter(
        (app) => !this.state.appsSelected.find(
          (sa) => sa.value.IDAplicacion === app.IDAplicacion
        )
      )
      .map((app) => ({
        label: app.nombre + " - " + app.titulo,
        value: { IDAplicacion: app.IDAplicacion, nombre: app.nombre, titulo: app.titulo },
      }));
    this.setState({ appsAvailable: appsAvailable });
  }

  async loadAllGruposForSubgroups() {
    await doFetch("SSO", "getAllGrupos", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          // Exclude self from available subgroups
          let allGrupos = data.DATA
            .filter((g) => g.IDGrupo !== this.state.data.IDGrupo)
            .map((g) => ({
              label: g.nombre,
              value: { IDGrupo: g.IDGrupo, nombre: g.nombre, descripcion: g.descripcion },
            }));

          let subgruposAvailable = allGrupos.filter(
            (g) => !this.state.subgruposSelected.find(
              (sg) => sg.value.IDGrupo === g.value.IDGrupo
            )
          );

          this.setState({
            allGrupos: allGrupos,
            subgruposAvailable: subgruposAvailable,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      });
  }

  async fillPermisos(selectedApp) {
    let appPermisoList = await this.getAppPermisions(selectedApp);

    let selectedForApp = this.state.mapAppPermisosSelected[selectedApp] || [];

    let permisoListAvailable = appPermisoList.filter(
      (appPer) =>
        !selectedForApp.find(
          (selPer) => selPer.value.IDPermiso === appPer.value.IDPermiso
        )
    );

    appPermisoList.sort((a, b) => this.permisosCompare(a, b));
    selectedForApp.sort((a, b) => this.permisosCompare(a, b));
    permisoListAvailable.sort((a, b) => this.permisosCompare(a, b));

    this.setState({
      appPermisoList: appPermisoList,
      permisoListAvailable: permisoListAvailable,
      permisoListSelected: selectedForApp,
      filaSeleccionadaAdd: null,
      filaSeleccionadaRemove: null,
    });
  }

  async getAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp) {
      this.props.onLoading(true);

      let method = "getAppPermisions?IDAplicacion=" + selectedApp;

      await doFetch("SSO", method, null)
        .then((response) => response.json())
        .then((data) => {
          for (let dat of data.DATA) {
            permisosList.push({ label: dat.nombre, value: dat });
          }
        })
        .catch((error) => {
          console.error("Error:", JSON.stringify(error, null, 2));
        })
        .finally(() => {
          this.props.onLoading(false);
        });
    }
    return permisosList;
  }

  closeModal() {
    this.props.onCloseModal();
  }

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "app":
        this.setState({ selectedApp: event.target.value });
        this.fillPermisos(event.target.value);
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState({ data });
        break;
    }
  }

  handleAddButtonClick(index) {
    this.setState({ filaSeleccionadaAdd: index });
  }

  handleRemoveButtonClick(index) {
    this.setState({ filaSeleccionadaRemove: index });
  }

  handleAddButtonDoubleClick(index, element) {
    if (index != null && element != null) {
      let permisoListAvailable = [...this.state.permisoListAvailable];
      permisoListAvailable.splice(index, 1);

      let permisoListSelected = [...this.state.permisoListSelected];
      permisoListSelected.push(element);
      permisoListSelected.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = { ...this.state.mapAppPermisosSelected };
      mapAppPermisosSelected[this.state.selectedApp] = permisoListSelected;

      this.setState({
        permisoListAvailable: permisoListAvailable,
        permisoListSelected: permisoListSelected,
        mapAppPermisosSelected: mapAppPermisosSelected,
        filaSeleccionadaAdd: null,
      });
    }
  }

  handleRemoveButtonDoubleClick(index, element) {
    if (index != null && element != null) {
      let permisoListSelected = [...this.state.permisoListSelected];
      permisoListSelected.splice(index, 1);

      let permisoListAvailable = this.state.appPermisoList.filter(
        (appPer) =>
          !permisoListSelected.find(
            (selPer) => selPer.value.IDPermiso === appPer.value.IDPermiso
          )
      );
      permisoListAvailable.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = { ...this.state.mapAppPermisosSelected };
      mapAppPermisosSelected[this.state.selectedApp] = permisoListSelected;

      this.setState({
        permisoListAvailable: permisoListAvailable,
        permisoListSelected: permisoListSelected,
        mapAppPermisosSelected: mapAppPermisosSelected,
        filaSeleccionadaRemove: null,
      });
    }
  }

  permisosCompare(a, b) {
    if (a.value.nombre > b.value.nombre) return 1;
    if (a.value.nombre < b.value.nombre) return -1;
    return 0;
  }

  /* ── Subgroup handlers ── */

  handleSubgrupoAddClick(index) {
    this.setState({ filaSubgrupoAdd: index });
  }

  handleSubgrupoRemoveClick(index) {
    this.setState({ filaSubgrupoRemove: index });
  }

  handleSubgrupoAddDoubleClick(index, element) {
    if (index != null && element != null) {
      let subgruposAvailable = [...this.state.subgruposAvailable];
      subgruposAvailable.splice(index, 1);

      let subgruposSelected = [...this.state.subgruposSelected];
      subgruposSelected.push(element);

      this.setState({
        subgruposAvailable,
        subgruposSelected,
        filaSubgrupoAdd: null,
      });
    }
  }

  handleSubgrupoRemoveDoubleClick(index, element) {
    if (index != null && element != null) {
      let subgruposSelected = [...this.state.subgruposSelected];
      subgruposSelected.splice(index, 1);

      let subgruposAvailable = this.state.allGrupos.filter(
        (g) => !subgruposSelected.find((sg) => sg.value.IDGrupo === g.value.IDGrupo)
      );

      this.setState({
        subgruposAvailable,
        subgruposSelected,
        filaSubgrupoRemove: null,
      });
    }
  }

  /* ── App association handlers ── */

  handleAppAddClick(index) {
    this.setState({ filaAppAdd: index });
  }

  handleAppRemoveClick(index) {
    this.setState({ filaAppRemove: index });
  }

  handleAppAddDoubleClick(index, element) {
    if (index != null && element != null) {
      let appsAvailable = [...this.state.appsAvailable];
      appsAvailable.splice(index, 1);

      let appsSelected = [...this.state.appsSelected];
      appsSelected.push(element);

      this.setState({
        appsAvailable,
        appsSelected,
        filaAppAdd: null,
      });
    }
  }

  handleAppRemoveDoubleClick(index, element) {
    if (index != null && element != null) {
      let appsSelected = [...this.state.appsSelected];
      appsSelected.splice(index, 1);

      let appsAvailable = this.state.appsData
        .filter(
          (app) => !appsSelected.find((sa) => sa.value.IDAplicacion === app.IDAplicacion)
        )
        .map((app) => ({
          label: app.nombre + " - " + app.titulo,
          value: { IDAplicacion: app.IDAplicacion, nombre: app.nombre, titulo: app.titulo },
        }));

      this.setState({
        appsAvailable,
        appsSelected,
        filaAppRemove: null,
      });
    }
  }

  // ── User management methods ──

  async loadAllUsers() {
    await doFetch("SSO", "getAllUsers", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          this.setState({ allUsers: data.DATA }, () => {
            this.updateUsersAvailable();
          });
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      });
  }

  updateUsersAvailable() {
    let grupoUsuarios = this.state.grupoUsuarios || [];
    let usersSelected = grupoUsuarios.map((u) => ({
      label: u.apodo || u.Apodo,
      value: { IDUsuario: u.IDUsuario || u.ID_Usuario, apodo: u.apodo || u.Apodo },
    }));

    let selectedIds = new Set(usersSelected.map((u) => u.value.IDUsuario));
    let usersAvailable = this.state.allUsers
      .filter((u) => !selectedIds.has(u.IDUsuario))
      .map((u) => ({
        label: u.apodo,
        value: { IDUsuario: u.IDUsuario, apodo: u.apodo },
      }));

    this.setState({ usersAvailable, usersSelected });
  }

  handleUserAddClick(index) {
    this.setState({ filaUserAdd: index });
  }

  handleUserRemoveClick(index) {
    this.setState({ filaUserRemove: index });
  }

  handleUserAddDoubleClick(index, element) {
    if (index != null && element != null) {
      let usersAvailable = [...this.state.usersAvailable];
      usersAvailable.splice(index, 1);

      let usersSelected = [...this.state.usersSelected];
      usersSelected.push(element);

      this.setState({
        usersAvailable,
        usersSelected,
        filaUserAdd: null,
      });
    }
  }

  handleUserRemoveDoubleClick(index, element) {
    if (index != null && element != null) {
      let usersSelected = [...this.state.usersSelected];
      usersSelected.splice(index, 1);

      let selectedIds = new Set(usersSelected.map((u) => u.value.IDUsuario));
      let usersAvailable = this.state.allUsers
        .filter((u) => !selectedIds.has(u.IDUsuario))
        .map((u) => ({
          label: u.apodo,
          value: { IDUsuario: u.IDUsuario, apodo: u.apodo },
        }));

      this.setState({
        usersAvailable,
        usersSelected,
        filaUserRemove: null,
      });
    }
  }

  async saveGrupoUsuarios(grupoId) {
    let result = false;
    this.props.onLoading(true);

    let userIds = this.state.usersSelected.map((u) => u.value.IDUsuario);

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userIds),
    };

    let method = "updateGrupoUsuarios?IDGrupo=" + grupoId;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async doSave(event) {
    event.preventDefault();

    let grupoId = await this.saveGrupo();
    if (grupoId) {
      let resPerm = await this.saveGrupoPermisos(grupoId);
      let resSub = await this.saveGrupoSubgrupos(grupoId);
      let resApps = await this.saveGrupoApps(grupoId);
      let resUsers = await this.saveGrupoUsuarios(grupoId);
      if (resPerm && resSub && resApps && resUsers) {
        this.props.onCloseModal();
      }
    }
  }

  async saveGrupo() {
    this.props.onLoading(true);
    let grupoId = null;

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.state.data),
    };

    await doFetch("SSO", "upsertGrupo", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          grupoId = data.DATA.IDGrupo || this.state.data.IDGrupo;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return grupoId;
  }

  async saveGrupoPermisos(grupoId) {
    this.props.onLoading(true);
    let result = false;

    // Build flat list of all permisos across all apps
    let permisosList = [];
    for (let [appId, permisos] of Object.entries(
      this.state.mapAppPermisosSelected
    )) {
      for (let permiso of permisos) {
        permisosList.push({
          IDAplicacionFK: { IDAplicacion: parseInt(appId) },
          IDPermisoFK: { IDPermiso: permiso.value.IDPermiso },
        });
      }
    }

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(permisosList),
    };

    let method = "updateGrupoPermisosApps?IDGrupo=" + grupoId;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async saveGrupoSubgrupos(grupoId) {
    this.props.onLoading(true);
    let result = false;

    let subgrupoIds = this.state.subgruposSelected.map(
      (sg) => sg.value.IDGrupo
    );

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(subgrupoIds),
    };

    let method = "updateGrupoSubgrupos?IDGrupo=" + grupoId;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async saveGrupoApps(grupoId) {
    this.props.onLoading(true);
    let result = false;

    let appsList = this.state.appsSelected.map((a) => ({
      IDAplicacionFK: { IDAplicacion: a.value.IDAplicacion },
    }));

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(appsList),
    };

    let method = "updateGrupoAplicaciones?IDGrupo=" + grupoId;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  setShow(event) {
    if (this.state.showGroupEditModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  render() {
    let isEdit = this.state.data.IDGrupo != null;

    return (
      <>
        <MDBModal
          show={this.state.showGroupEditModal}
          setShow={(event) => this.setShow(event)}
          tabIndex="-1"
        >
          <MDBModalDialog size="xl">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle style={{ fontSize: "1.05rem" }}>
                  <MDBIcon fas icon={isEdit ? "edit" : "plus-circle"} className="me-2" />
                  {isEdit
                    ? "Editar grupo: " + this.state.data.nombre
                    : "Nuevo grupo"}
                </MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer className="sso-modal-form">
                  {/* ── Datos del grupo ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="layer-group" className="me-2" />
                    Datos del grupo
                  </h6>
                  <MDBRow>
                    <MDBCol md="6">
                      <MDBInput
                        className="mb-3"
                        type="text"
                        id="nombre"
                        label="Nombre del grupo"
                        value={this.state.data.nombre}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                    <MDBCol md="6">
                      <MDBTextArea
                        className="mb-3"
                        id="descripcion"
                        label="Descripción"
                        rows={2}
                        value={this.state.data.descripcion}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                  </MDBRow>

                  {/* ── Usuarios ── */}
                  {isEdit && (
                    <>
                      <h6 className="sso-section-title">
                        <MDBIcon fas icon="user" className="me-2" />
                        Usuarios
                      </h6>
                      <DualPicklist
                        available={this.state.usersAvailable}
                        selected={this.state.usersSelected}
                        titleLeft="Disponibles"
                        titleRight="Asignados"
                        height="200px"
                        onAdd={(item) => this.handleUserAddDoubleClick(
                          this.state.usersAvailable.indexOf(item), item
                        )}
                        onRemove={(item) => this.handleUserRemoveDoubleClick(
                          this.state.usersSelected.indexOf(item), item
                        )}
                      />
                    </>
                  )}

                  {/* ── Permisos del grupo ── */}
                  <h6 className="sso-section-title mt-3">
                    <MDBIcon fas icon="key" className="me-2" />
                    Permisos del grupo
                  </h6>
                  <MDBRow className="mb-3">
                    <MDBCol md="5">
                      <Form.Label htmlFor="app" style={{ fontSize: "0.82rem" }}>Aplicación</Form.Label>
                      <Form.Select
                        size="sm"
                        id="app"
                        value={this.state.selectedApp}
                        onChange={(event) => this.handleChange(event)}
                      >
                        {this.state.appsData.map((element, index) => (
                          <option key={index} value={element.IDAplicacion}>
                            {element.nombre + " — " + element.titulo}
                          </option>
                        ))}
                      </Form.Select>
                    </MDBCol>
                  </MDBRow>
                  <DualPicklist
                    available={this.state.permisoListAvailable}
                    selected={this.state.permisoListSelected}
                    titleLeft="Disponibles"
                    titleRight="Seleccionados"
                    height="200px"
                    onAdd={(item) => this.handleAddButtonDoubleClick(
                      this.state.permisoListAvailable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleRemoveButtonDoubleClick(
                      this.state.permisoListSelected.indexOf(item), item
                    )}
                  />

                  {/* ── Aplicaciones asociadas ── */}
                  <h6 className="sso-section-title mt-3">
                    <MDBIcon fas icon="th-large" className="me-2" />
                    Aplicaciones asociadas
                    <span className="text-muted ms-2" style={{ fontSize: "0.75rem", fontWeight: "normal" }}>
                      (un usuario pertenece a una app si tiene un grupo asociado)
                    </span>
                  </h6>
                  <DualPicklist
                    available={this.state.appsAvailable}
                    selected={this.state.appsSelected}
                    titleLeft="Apps disponibles"
                    titleRight="Apps asignadas"
                    height="180px"
                    onAdd={(item) => this.handleAppAddDoubleClick(
                      this.state.appsAvailable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleAppRemoveDoubleClick(
                      this.state.appsSelected.indexOf(item), item
                    )}
                  />

                  {/* ── Subgrupos ── */}
                  {isEdit && (
                    <>
                      <h6 className="sso-section-title mt-3">
                        <MDBIcon fas icon="sitemap" className="me-2" />
                        Subgrupos
                        <span className="text-muted ms-2" style={{ fontSize: "0.75rem", fontWeight: "normal" }}>
                          (hereda permisos de subgrupos)
                        </span>
                      </h6>
                      <DualPicklist
                        available={this.state.subgruposAvailable}
                        selected={this.state.subgruposSelected}
                        titleLeft="Grupos disponibles"
                        titleRight="Subgrupos asignados"
                        height="180px"
                        onAdd={(item) => this.handleSubgrupoAddDoubleClick(
                          this.state.subgruposAvailable.indexOf(item), item
                        )}
                        onRemove={(item) => this.handleSubgrupoRemoveDoubleClick(
                          this.state.subgruposSelected.indexOf(item), item
                        )}
                      />
                    </>
                  )}

                  <div className="sso-modal-save-bar">
                    <MDBBtn onClick={(event) => this.doSave(event)}>
                      <MDBIcon fas icon="save" className="me-2" />
                      Guardar
                    </MDBBtn>
                  </div>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
